/**
 * Raisons pour lesquelles les imputations d'un financement ne peuvent pas etre saisies
 */
const BLOCAGE_SAISIE_IMPUTATION = {
	/** L'exercice du financement n'est pas saisi (bloquant uniquement en gestion par service) */
	EXERCICE_NON_SAISI: 'EXERCICE_NON_SAISI',
	/** L'exercice n'existe pas en comptabilite et n'est pas posterieur au dernier exercice */
	EXERCICE_INEXISTANT: 'EXERCICE_INEXISTANT',
	/** Le service n'est rattache a aucun espace budgetaire sur l'exercice de saisie */
	SERVICE_SANS_ESPACE: 'SERVICE_SANS_ESPACE',
} as const;

export type BlocageSaisieImputation =
	(typeof BLOCAGE_SAISIE_IMPUTATION)[keyof typeof BLOCAGE_SAISIE_IMPUTATION];

export default BLOCAGE_SAISIE_IMPUTATION;
